module.exports = __webpack_public_path__ + "img/plus.9f48b36f.svg";